module.exports = __webpack_public_path__ + "static/media/paypal-logo.90e7fcb4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/ways-to-pay/paypal-logo.png
// module id = 2286
// module chunks = 0